export class ContactReport {
    AccountID:number
    FromDate: Date;
    ToDate: Date;
    ZoneID: number;
    UserID: number;
    DealerID: number;
    DealerSEID: number;
}
